"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var Forms = (function (_super) {
    __extends(Forms, _super);
    function Forms(baseUrl, path) {
        if (path === void 0) { path = "forms"; }
        _super.call(this, baseUrl, path);
    }
    Forms.prototype.getById = function (id) {
        var i = new Form(this);
        i.concat("('" + id + "')");
        return i;
    };
    return Forms;
}(queryable_1.QueryableCollection));
exports.Forms = Forms;
var Form = (function (_super) {
    __extends(Form, _super);
    function Form(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    return Form;
}(queryable_1.QueryableInstance));
exports.Form = Form;
